import React from 'react';
import { Checkbox, Icon } from '@fluentui/react';
import Api from '../../../services/Api'

class TreeComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = ({
            Children: [],
            MyChildrenExpanded: false
        })
    }

    fitPossibilities(posts) {
        this.setState({ Children: posts })
    }

    amIselected() {
        if (!this.props.selectedItem) return false;
        return this.props.child.key === this.props.selectedItem.key;
    }

    handleExpansion() {
        if (!this.state.MyChildrenExpanded) {
            // let depth = Number(this.props.child.depth) + 1;
            Api.get(this.props.url + '?parent=' + this.props.child.key)
                .then(res => res.data)
                .then(posts => {
                    this.fitPossibilities(posts);
                }
                );
        }
        this.setState({ MyChildrenExpanded: !this.state.MyChildrenExpanded });
    }

    handleSelection() {
        this.props.itemSelector(this.props.child);
    }

    getTextFromItem(item: ITag): string {
        return item.key !== item.value && item.key !== 'Cross' ? `${item.key} - ${item.value}` : item.value;
    }

    render() {
        const selection = this.amIselected();
        const margin = this.props.child.depth * 10;
        const children = this.state.Children.map(item => 
            <div key={item.key} style={{ marginLeft: margin + 'px' }}>
                <TreeComponent
                    key={item.key}
                    child={item}
                    itemSelector={this.props.itemSelector}
                    selectedItem={this.props.selectedItem}
                    url={this.props.url}
                    isParent = {item.isParent}
                />
            </div>
        )
        const showChildren = this.state.MyChildrenExpanded ? <div className='children'> {children} </div> : null;
        const expandIconVisibility = {
            visibility: this.props.child.isParent ? 'visible' : 'hidden'
        };

        return (
            <div className='wizard-item'>
                <div onClick={this.handleExpansion.bind(this)} className="expand-icon" style={expandIconVisibility} >
                    <Icon iconName="CaretHollow" />
                </div>
                <Checkbox id={this.props.child.key} label={this.getTextFromItem(this.props.child)} checked={selection} onChange={this.handleSelection.bind(this)} />
                <div className='wizard-item'>
                    {showChildren}
                </div>
            </div>
        );
    }
}



export default TreeComponent








// WEBPACK FOOTER //
// ./src/components/CreateSite/CommonComponents/TreeComponent.js